import React, { useEffect, useState } from "react";
import Webmenu from "../../../layouts/webmenu";
import Topbar from "../../../layouts/topbar";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { getCoverageById, updateCoverage } from "../../../actions/CoverageActions";
import Mobilemenu from "../../../layouts/mobile-menu";

function EditCoverage() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();

    const [name, setName] = useState('');

    useEffect(() => {
        dispatch(getCoverageById(params.id));
    }, [])

    const coverage = useSelector(state => state?.coverage?.coverage);
    const loading = useSelector(state => state?.loading?.loading);

    useEffect(() => {
        if (Object.keys(coverage).length > 0) {
            setName(coverage.name);
        }
    }, [coverage])

    const save = () => {
        if (name.length == 0) {

        } else {
            let data = {
                name: name,
            }
            dispatch(updateCoverage(data, params.id));
        }
        // // window.location.href = ('/coverage')
    }

    return (
        <React.Fragment>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    <div className="intro-y d-flex align-items-center mt-8">
                        <h2 className="fs-lg fw-medium me-auto">
                            Edit Coverage
                        </h2>
                    </div>
                    <div className="grid columns-12 gap-6 mt-5">
                        <div className="intro-y g-col-12 g-col-lg-6">
                            {/* <!-- BEGIN: Form Layout --> */}
                            <div className="intro-y box p-5">
                                <div>
                                    <label for="crud-form-1" className="form-label">Name</label>
                                    <input id="crud-form-1" type="text" value={name} onChange={(e) => setName(e.target.value)} className="form-control w-full" placeholder="Enter Name" />
                                </div>
                                <div className="text-end mt-5">
                                    <button type="button" onClick={() => navigate('/coverage')} className="btn btn-outline-secondary w-24 me-1">Back</button>
                                     <button onClick={save} type="button" disabled={loading ? true : false} className="btn btn-primary w-24 ms-2">Save</button>
                                </div>
                            </div>
                            {/* <!-- END: Form Layout --> */}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default EditCoverage;